module.exports = __webpack_public_path__ + "img/9788995995204.62054da7.jpg";